import createLucideIcon from '../createLucideIcon';

const Rat = createLucideIcon('Rat', [
  [
    'path',
    {
      d: 'M14 16.5v-.77a2.73 2.73 0 0 1 3.27-2.68l3.02.6a1.4 1.4 0 0 0 1.5-2.08l-1.63-2.8a3 3 0 1 0-3.35-4.82',
      key: '1imirm',
    },
  ],
  ['path', { d: 'M16 9h-.01', key: '10b73d' }],
  [
    'path',
    {
      d: 'M17 5.12V5a3 3 0 1 0-5.24 2h-1A6.77 6.77 0 0 0 4 13.77C4 16.1 5.9 18 8.23 18H9',
      key: 'pc8a32',
    },
  ],
  ['path', { d: 'M13 22H4a2 2 0 1 1 0-4h12', key: 'zccc2i' }],
  [
    'path',
    {
      d: 'M13.67 18c.21-.44.33-.94.33-1.45A3.65 3.65 0 0 0 10.26 13',
      key: '32fq2j',
    },
  ],
]);

export default Rat;
